import classNames from 'classnames';
import { useParams, useSearchParams } from 'wouter';

import Icon from 'components/Icon/Icon';
import SearchField from 'components/SearchField';
import Sorting from 'components/Sorting';
import SubHeader from 'components/SubHeader';
import { CasinoGamesProvider } from 'pages/CasinoPage/casino.context';
import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';

import ProviderGames from './Games';

import styles from './ProviderGamesPage.module.scss';

const ProviderGamesPage = () => {
  const layout = useLayout();
  const params = useParams<{ provider: string }>();
  const [searchParams] = useSearchParams();

  return (
    <section className={classNames(styles.wrapper, styles[layout])}>
      <CasinoGamesProvider>
        <SubHeader>
          <div className={styles['sub-header']}>
            <Icon name="profile-circle" width={24} height={24} />
            <span>{params.provider}</span>
          </div>
        </SubHeader>
        <div className={styles['layout-content']}>
          <SearchField
            minLength={2}
            placeholder="search_provider"
            className={styles['search-form']}
          />
          <div className={styles.info}>
            <div className={styles['info-label-wrapper']}>
              <Icon name="providers.bold" />
              <p className={styles.label}>
                {params.provider} <Translation message="all_games" />
              </p>
            </div>
            <Sorting />
          </div>
          <ProviderGames
            provider={params.provider}
            sortDirection={searchParams.get('sort') as 'asc' | 'desc'}
            search={searchParams.get('q') as string}
          />
        </div>
      </CasinoGamesProvider>
    </section>
  );
};

export default ProviderGamesPage;
